/**
 * FairwayBid – Regeln und Lebenslauf einer Anfrage
 *
 * Der Abschnitt "Was es kostet – und welche Regeln gelten" bestand aus rund
 * 1.500 Zeichen Fließtext. Darin steckten aber gar keine Absätze, sondern
 * drei Regeln und ein Ablauf mit drei Phasen. Als Text muss man ihn lesen;
 * als Phasen sieht man ihn.
 *
 * Die Überschriften hier sind Etiketten, keine neuen Aussagen – der Satz
 * darunter stammt weiter aus der Console. Die Fristen (7/14/21/30, +14, 60)
 * sind Produktverhalten und stehen deshalb im Code, wie die Tarifstunden.
 */

/** Kurze Etiketten für die drei Regeln aus dem Einstieg des Abschnitts. */
export const RULE_LABELS = [
  { beginntMit: 'Für Golfanlagen ist FairwayBid kostenlos', label: 'Für Golfanlagen kostenlos' },
  { beginntMit: 'Händler und Hersteller zahlen', label: 'Händler zahlen monatlich' },
  { beginntMit: 'Damit der Vergleich fair bleibt', label: 'Kontaktdaten erst nach Zuschlag' },
];

export const labelFuer = absatz => {
  const t = String(absatz || '').trim();
  return RULE_LABELS.find(r => t.startsWith(r.beginntMit))?.label || null;
};

/**
 * Der Lebenslauf einer Anfrage als Phasen. Die Zeitangaben sind das, was
 * zählt – sie stehen deshalb groß und die Erklärung klein darunter.
 */
export const LIFECYCLE = [
  {
    key: 'angebote',
    span: '7 bis 30 Tage',
    title: 'Angebotsfrist',
    text:
      'Die Golfanlage setzt beim Einstellen 7, 14, 21 oder 30 Tage. In dieser Zeit geben die passenden Händler ihre Angebote ab.',
  },
  {
    key: 'entscheidung',
    span: '+ 14 Tage',
    title: 'Entscheidung',
    text:
      'Die Anfrage bleibt sichtbar, neue Angebote sind nicht mehr möglich. Die Anlage vergleicht in Ruhe und vergibt den Auftrag.',
  },
  {
    key: 'geschlossen',
    span: 'spätestens Tag 60',
    title: 'Geschlossen',
    text:
      'Geschlossen heißt nicht gelöscht: Anfrage, Angebote und Nachrichten bleiben im Konto. Derselbe Bedarf ist im nächsten Jahr mit zwei Klicks wieder veröffentlicht.',
  },
];

/** Die Begründung – wichtig, aber nicht auf den ersten Blick nötig. */
export const LIFECYCLE_WHY = {
  frage: 'Warum wir das begrenzen',
  antwort:
    'Ein Händler soll kein Angebotskontingent für eine Anfrage verbrauchen, die längst vergeben ist. Und eine Golfanlage soll nicht Wochen nach der Entscheidung noch Anrufe zu einem erledigten Vorgang bekommen.',
};
